//@flow
import React from 'react';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  makeStyles,
} from '@material-ui/core';

import type {Theme} from '@material-ui/core';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';

type Props = {
  open: boolean,
  onClose: () => void,
};
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '380px',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },

  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },

  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },

  body: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  formSectionRadioGroup: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '.5rem',
  },

  footer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
  },
  button: {
    maxWidth: '320px',
  },
}));

export default function EditTaxInvoiceModal(props: Props) {
  const {open, onClose} = props;

  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={onClose}>
      <aside className={classes.root}>
        <header className={classes.header}>
          <Typography className={classes.title}>Editar Comprobante</Typography>
        </header>

        <div className={classes.body}>
          <div className={classes.formSection}>
            <Typography className={classes.formSectionTitle}>
              Tipo de comprobante
            </Typography>

            <RadioGroup
              aria-label="quiz"
              name="quiz"
              className={classes.formSectionRadioGroup}
            >
              <FormControlLabel
                value="best"
                control={<Radio color="primary" />}
                label="Por producto"
              />
              <FormControlLabel
                value="worst"
                control={<Radio color="primary" />}
                label="Por Monto"
              />
            </RadioGroup>
          </div>
          <div className={classes.formSection}>
            <Typography className={classes.formSectionTitle}>
              Razón Social
            </Typography>
            <CustomTextField placeholder="Corporación L&B S.A.C" />
          </div>
          <div className={classes.formSection}>
            <Typography className={classes.formSectionTitle}>RUC</Typography>
            <CustomTextField placeholder="0120491294921" />
          </div>
          <div className={classes.formSection}>
            <Typography className={classes.formSectionTitle}>
              Impuestos en la orden
            </Typography>
            <CustomTextField placeholder="0120491294921" />
          </div>
        </div>
        <footer className={classes.footer}>
          <CustomButton
            className={classes.button}
            variant="contained"
            fullWidth
          >
            Guardar Cambios
          </CustomButton>
        </footer>
      </aside>
    </CustomModal>
  );
}
